"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmobilityProductsResponse = exports.EmobilityProduct = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class EmobilityProduct extends base_models_1.Serializable {
}
exports.EmobilityProduct = EmobilityProduct;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'product id, for example charge card id or charge point identifier',
        example: 'NLESSE91827364',
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", String)
], EmobilityProduct.prototype, "id", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'product type, for example charge card, charge point ',
        example: 'ChargeCard',
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", String)
], EmobilityProduct.prototype, "productType", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2024-05-05',
        description: `Valid from`,
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], EmobilityProduct.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2024-05-05',
        description: `Valid to`,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    tslib_1.__metadata("design:type", String)
], EmobilityProduct.prototype, "validTo", void 0);
class EmobilityProductsResponse extends base_models_1.Serializable {
}
exports.EmobilityProductsResponse = EmobilityProductsResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: [
            {
                id: 'NLESSE91827364',
                type: 'ChargeCard',
                reimbursed: false,
                validFrom: '2024-02-29',
                validTo: '2025-02-29',
            },
        ],
        description: 'Emobility products',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => EmobilityProduct),
    tslib_1.__metadata("design:type", Array)
], EmobilityProductsResponse.prototype, "results", void 0);
